import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const shutdownReportsKey = () => ['shutdownReports'];

const shutdownReportsQuery = async () => {
  return await request.get(
    `/Report/awailable`,
    { reportType: 'Alerts' },
    `При загрузке отчетов произошла ошибка`
  );
};

export const useShutdownReports = (options) =>
  useQuery(shutdownReportsKey(), shutdownReportsQuery, options);
